import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import * as url from "../../../helpers/url_helper";
import $ from "jquery";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from "axios";
import SelectFilters, { FILTER_CONFIG } from "./SelectFilters";
import FilterStatisticsCards from "./FilterStatisticsCards";
import { PremisesListResponse } from "../../../helpers/response/Admin/PremiseListResponse";
import getStorageData from "../../../Utils/getStorageData";
import {
  getFilterCount,
  getSelectedFilter,
  setActivityFilter,
  setDeviceFilter,
  setCityFilter,
} from "../../../store/slices/SegmentResponseSlice";
import Request from "../../../helpers/request";
import SegmentTable from "./SegmentTable";
import SaveSegment from "./SaveSegment";
import EditSegment from "./EditSegment";

type ActivityFilterPayload = {
  filterType: string;
  minutes: number;
  minCount: number;
};

type DeviceFilterPayload = {
  filterType: string;
  filterCount: string;
  filterState: string;
};

type CityFilterPayload = {
  cityId: string[];
};

const Index = () => {
  let { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedList = useSelector(
    (state: any) => state.SegmentResponse.selectedFilter
  );
  // const {
  //   appOpenValue,
  //   appOperateValue,
  //   appNotOpenValue,
  //   appNotOperateValue,
  //   sceneCount,
  //   sceneRunCount,
  //   automationCount,
  //   automationRunCount,
  // } = useSelector((state: any) => state.AnalyticsResponse.filterCount);

  const [loading, setLoading] = useState(false);
  const [selectedPresetId, setSelectedPresetId] = useState<string | null>(null);
  const [isOpenAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [isSaveSegmentModalOpen, setSaveSegmentModalOpen] = useState(false);
  const [isEditSegmentModalOpen, setEditSegmentModalOpen] = useState(false);
  const [segmentFormData, setSegmentFormData] = useState({
    name: "",
    description: "",
    updateCycle: "daily",
    isLiveSegmentation: true,
    isActive: true,
  });
  const [advancedFilter, setAdvancedFilter] = useState<any>(selectedList);
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const appliedFiltersRef = useRef<string[]>([]);
  const [hasApplied, setHasApplied] = useState(false);
  const [recordsTotal, setRecordsTotal] = useState<number | null>(null);
  const [recordsFiltered, setRecordsFiltered] = useState<number | null>(null);

  const [rules, setRules] = useState([
    {
      category: "",
      option: "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    },
  ]);
  const [ruleErrors, setRuleErrors] = useState<
    {
      category?: string;
      option?: string;
      number?: string;
      minutes?: string;
      minCount?: string;
      activityType?: string;
      deviceType?: string;
      deviceCount?: string;
      deviceState?: string;
      cityIds?: string;
      cityLabel?: string;
    }[]
  >([]);
  const controllerRef = useRef<AbortController | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const activityFilterRef = useRef<ActivityFilterPayload | null>(null);
  const deviceFilterRef = useRef<DeviceFilterPayload | null>(null);
  const cityFilterRef = useRef<CityFilterPayload | null>(null);
  const [cityOptions, setCityOptions] = useState<any[]>([]);

  const userType = getStorageData().userType;
  const token = localStorage.getItem("Authorization");

  // ---------------- BUILD RULES ----------------
  const buildFilters = (
    updatedRules: any
  ): {
    filters: string[];
    activityPayload: ActivityFilterPayload | null;
    devicePayload: DeviceFilterPayload | null;
    cityPayload: CityFilterPayload | null;
  } => {
    let finalFilters: string[] = [];
    let activityPayload: ActivityFilterPayload | null = null;
    let devicePayload: DeviceFilterPayload | null = null;
    let cityPayload: CityFilterPayload | null = null;

    updatedRules.forEach((rule: any) => {
      if (!rule.category || !rule.option) return;

      const categoryBlock = FILTER_CONFIG[rule.category];
      const optionItem = categoryBlock.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (!optionItem) return;

      // Normal checkbox-based filter
      if (!optionItem.type) {
        finalFilters.push(optionItem.value);
      }

      // Numeric filter
      if (optionItem.type === "number") {
        if (rule.number && Number(rule.number) > 0) {
          finalFilters.push(`${optionItem.prefix}-${rule.number}`);
        }
      }

      // Activity filter: requires activityType, minutes, minCount
      if (optionItem.type === "activity") {
        if (
          rule.activityType &&
          rule.minutes &&
          Number(rule.minutes) > 0 &&
          rule.minCount &&
          Number(rule.minCount) > 0
        ) {
          activityPayload = {
            filterType: rule.activityType,
            minutes: Number(rule.minutes),
            minCount: Number(rule.minCount),
          };
        }
      }

      if (optionItem.type === "device") {
        if (rule.deviceType && rule.deviceCount && rule.deviceState) {
          devicePayload = {
            filterType: rule.deviceType,
            filterCount: rule.deviceCount,
            filterState: rule.deviceState,
          };
        }
      }

      if (optionItem.type === "city") {
        if (rule.cityIds) {
          const ids = rule.cityIds
            .split(",")
            .map((id: string) => id.trim())
            .filter(Boolean);
          if (ids.length) {
            cityPayload = { cityId: ids };
          }
        }
      }
    });

    return {
      filters: finalFilters,
      activityPayload,
      devicePayload,
      cityPayload,
    };
  };

  const fetchCityOptions = async (keyword: string, force = false) => {
    if (!force && (!keyword || keyword.length < 2)) {
      setCityOptions([]);
      return;
    }
    try {
      const res = await axios.get(
        `${url.BASE_URL}${url.GET_SEARCH_CITY_URL}?keyword=${encodeURIComponent(
          keyword
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const list = res.data?.data || res.data || [];
      const mapped =
        Array.isArray(list) && list.length
          ? list
              .map((item: any) => {
                const value = item.id || item._id || item.value;
                const label = item.name || item.label || item.value;
                if (!value) return null;
                return { value, label };
              })
              .filter(Boolean)
          : [];
      setCityOptions(mapped);
    } catch (err) {
      console.error("City search failed", err);
      setCityOptions([]);
    }
  };

  const buildRulesFromFilter = (filterValue: string) => {
    const defaults = {
      category: "",
      option: "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    };
    if (!filterValue) return [];
    const parts = filterValue
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    const rulesArr: any[] = [];
    parts.forEach((val) => {
      let matchedCategory: string | null = null;
      let matchedOption: string = val;
      let matchedNumber: string = "";

      // Check if value contains a dash (prefix-number format)
      if (val.includes("-")) {
        const [prefix, number] = val.split("-", 2);
        matchedOption = prefix;
        matchedNumber = number;
      }

      Object.entries(FILTER_CONFIG).forEach(([catKey, catVal]: any) => {
        if (matchedCategory) return;
        const hit = (catVal.options || []).find(
          (opt: any) =>
            opt.value === matchedOption || opt.prefix === matchedOption
        );
        if (hit) {
          matchedCategory = catKey;
        }
      });
      if (matchedCategory) {
        rulesArr.push({
          ...defaults,
          category: matchedCategory,
          option: matchedOption,
          number: matchedNumber,
        });
      }
    });
    return rulesArr;
  };

  const getCitySelectedOption = (value: string) => {
    if (!value) return null;
    const found = cityOptions.find((opt: any) => opt.value === value);
    const labelFallback =
      rules.find((r) => r.cityIds === value)?.cityLabel || value;
    return found || { value, label: labelFallback };
  };

  const getSelectValue = (options: any[], value: string) =>
    options.find((opt) => opt.value === value) || null;

  const updateCategory = (index: any, category: any) => {
    const updated = [...rules];
    updated[index] = {
      category,
      option:
        category === "activity"
          ? "activityFilter"
          : category === "device"
          ? "deviceFilter"
          : category === "city"
          ? "cityFilter"
          : "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    };
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateOption = (index: any, option: any) => {
    const updated = [...rules];
    updated[index].option = option;
    updated[index].number = "";
    updated[index].minutes = "";
    updated[index].minCount = "";
    updated[index].activityType = "";
    updated[index].deviceType = "";
    updated[index].deviceCount = "";
    updated[index].deviceState = "";
    updated[index].cityIds = "";
    updated[index].cityLabel = "";
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateNumber = (index: any, number: any) => {
    const updated = [...rules];
    updated[index].number = number;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateActivityType = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].activityType = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateMinutes = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].minutes = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateMinCount = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].minCount = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceType = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceType = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceCount = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceCount = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceState = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceState = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateCityIds = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].cityIds = value;
    updated[index].cityLabel =
      cityOptions.find((o: any) => o.value === value)?.label || "";
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const addRule = () => {
    setRules([
      ...rules,
      {
        category: "",
        option: "",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      },
    ]);
    setRuleErrors([...ruleErrors, {}]);
  };

  const removeRule = (index: any) => {
    const updatedRules = rules.filter((_, i) => i !== index);
    const updatedErrors = ruleErrors.filter((_, i) => i !== index);
    setRules(updatedRules);
    setRuleErrors(updatedErrors);
  };

  const resetCounts = () => {
    dispatch(
      getFilterCount({
        appOpenValue: "1",
        appOperateValue: "1",
        appNotOpenValue: "1",
        appNotOperateValue: "1",
        sceneCount: "1",
        sceneRunCount: "1",
        automationCount: "1",
        automationRunCount: "1",
      })
    );
  };

  useEffect(() => {
    dispatch(getSelectedFilter([]));
    dispatch(setActivityFilter(null));
    dispatch(setDeviceFilter(null));
    dispatch(setCityFilter(null));
    resetCounts();
    appliedFiltersRef.current = [];
    activityFilterRef.current = null;
    deviceFilterRef.current = null;
    cityFilterRef.current = null;
    setCityOptions([]);
  }, []);

  const handleAdvancedFilterNew = (name?: any, value?: string) => {
    if (!value) return;

    let updatedList = [...selectedList];

    // 1️⃣ Toggle remove if already selected
    if (updatedList.includes(value)) {
      updatedList = updatedList.filter((v) => v !== value);
    } else {
      // 2️⃣ Remove previous values from the same category
      updatedList = updatedList.filter((v) => !v.startsWith(name));

      updatedList.push(value);
    }

    dispatch(getSelectedFilter(updatedList));
  };

  // <button class="column-click" style="border: none; outline: none; background: none;"><span class="badge bg-primary" style="height: 25px; width: 60px; font-size: 12px; padding: 6px;">Detail</span></button>

  const toggleAdvanceFilter = () => {
    setOpenAdvancedFilter(!isOpenAdvancedFilter);
  };

  const handleAdvancedFilter = (name?: any, value?: string) => {
    // var list = [];
    var selectedList1 = [];

    if (selectedList.includes(value)) {
      const filterData = selectedList.filter((e: string) => e != value);
      dispatch(getSelectedFilter(filterData));
      // setAdvancedFilter(filterData)
    } else if (
      selectedList.some((item: any) =>
        item?.includes(name?.target?.name ? name?.target?.name : name)
      )
    ) {
      const filterData = selectedList.filter(
        (e: string) =>
          !e.includes(name?.target?.name ? name?.target?.name : name)
      );
      filterData.push(value);
      dispatch(getSelectedFilter(filterData));
    } else {
      selectedList1.push(...advancedFilter, value);
      dispatch(getSelectedFilter([...selectedList, value]));
      // setAdvancedFilter([...advancedFilter, value])
    }
    // console.log("selectedList", selectedList1);
  };

  const resetAdvanceFilterCount = () => {
    dispatch(
      getFilterCount({
        appOpenValue: "1",
        appOperateValue: "1",
        appNotOpenValue: "1",
        appNotOperateValue: "1",
        sceneCount: "1",
        sceneRunCount: "1",
        automationCount: "1",
        automationRunCount: "1",
      })
    );
  };

  useEffect(() => {
    if (!state?.isReload) {
      dispatch(getSelectedFilter([]));
      dispatch(setActivityFilter(null));
      dispatch(setDeviceFilter(null));
      dispatch(setCityFilter(null));
      activityFilterRef.current = null;
      deviceFilterRef.current = null;
      cityFilterRef.current = null;
      setCityOptions([]);
      resetAdvanceFilterCount();
    }
  }, []);

  const handleAdvancedFilterCount = (name: string, e: any) => {
    if (Number(e.target.value) < 0) {
      dispatch(getFilterCount({ [e.target.name]: "1" }));
    } else if (Number(e.target.value) <= 999) {
      dispatch(getFilterCount({ [e.target.name]: e.target.value }));
    }
    if (selectedList.some((item: string) => item.includes(name))) {
      handleAdvancedFilter(name, `${name}-${e.target.value}`);
    }
  };

  // Check if there's at least one valid rule
  const hasValidRules = () => {
    return rules.some((rule) => {
      if (!rule.category || !rule.option) return false;

      const categoryBlock = FILTER_CONFIG[rule.category];
      if (!categoryBlock) return false;

      const optionItem = categoryBlock.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (!optionItem) return false;

      // For number type filters, number must be filled and > 0
      if (optionItem.type === "number") {
        return rule.number && Number(rule.number) > 0;
      }

      if (optionItem.type === "activity") {
        return (
          rule.activityType &&
          rule.minutes &&
          Number(rule.minutes) > 0 &&
          rule.minCount &&
          Number(rule.minCount) > 0
        );
      }

      if (optionItem.type === "device") {
        return rule.deviceType && rule.deviceCount && rule.deviceState;
      }

      if (optionItem.type === "city") {
        return rule.cityIds && rule.cityIds.trim().length > 0;
      }

      // For non-number filters, category and option are enough
      return true;
    });
  };

  const validateFilters = () => {
    // Normalize implicit options for activity/device
    const normalizedRules = rules.map((rule) => {
      if (rule.category === "activity" && !rule.option) {
        return { ...rule, option: "activityFilter" };
      }
      if (rule.category === "device" && !rule.option) {
        return { ...rule, option: "deviceFilter" };
      }
      return rule;
    });

    setRules(normalizedRules);

    const { filters, activityPayload, devicePayload, cityPayload } =
      buildFilters(normalizedRules);

    // Build per-rule errors
    const currentErrors = normalizedRules.map((rule) => {
      const err: {
        category?: string;
        option?: string;
        number?: string;
        minutes?: string;
        minCount?: string;
        activityType?: string;
        deviceType?: string;
        deviceCount?: string;
        deviceState?: string;
        cityIds?: string;
      } = {};
      if (!rule.category) {
        err.category = "Category is required";
      }

      const categoryBlock = FILTER_CONFIG[rule.category];
      const optionItem = categoryBlock?.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (rule.category && !rule.option) {
        err.option = "Condition is required";
      }

      if (
        optionItem?.type === "number" &&
        (!rule.number || Number(rule.number) <= 0)
      ) {
        err.number = "Enter a value greater than 0";
      }

      if (optionItem?.type === "activity") {
        if (!rule.activityType) {
          err.activityType = "Select activity type";
        }
        if (!rule.minutes || Number(rule.minutes) <= 0) {
          err.minutes = "Minutes must be greater than 0";
        }
        if (!rule.minCount || Number(rule.minCount) <= 0) {
          err.minCount = "Min count must be greater than 0";
        }
      }

      if (optionItem?.type === "device") {
        if (!rule.deviceType) {
          err.deviceType = "Select device type";
        }
        if (!rule.deviceCount) {
          err.deviceCount = "Enter count or range";
        }
        if (!rule.deviceState) {
          err.deviceState = "Select device state";
        }
      }

      if (optionItem?.type === "city") {
        if (!rule.cityIds || !rule.cityIds.trim()) {
          err.cityIds = "Enter one or more city ids";
        }
      }

      return err;
    });

    setRuleErrors(currentErrors);
    setRules(normalizedRules);

    const hasRuleErrors = currentErrors.some(
      (e) =>
        e.category ||
        e.option ||
        e.number ||
        e.minutes ||
        e.minCount ||
        e.activityType ||
        e.deviceType ||
        e.deviceCount ||
        e.deviceState ||
        e.cityIds
    );

    if (hasRuleErrors) {
      toast.error("Please fix validation errors before applying");
      return null;
    }

    if (!filters.length && !activityPayload && !devicePayload && !cityPayload) {
      toast.error("Please add at least one valid filter before applying");
      return null;
    }

    // persist normalized rules for UI
    setRules(normalizedRules);
    return { filters, activityPayload, devicePayload, cityPayload };
  };

  const handleApplyFilter = async () => {
    const validated = validateFilters();
    if (!validated) {
      setHasApplied(false);
      return false;
    }
    const { filters, activityPayload, devicePayload, cityPayload } = validated;

    appliedFiltersRef.current = filters;
    activityFilterRef.current = activityPayload;
    deviceFilterRef.current = devicePayload;
    cityFilterRef.current = cityPayload;
    setAppliedFilters(filters);
    dispatch(getSelectedFilter(filters));
    dispatch(setActivityFilter(activityPayload));
    dispatch(setDeviceFilter(devicePayload));
    dispatch(setCityFilter(cityPayload));
    setHasApplied(true);

    // Call API on apply
    try {
      setLoading(true);

      // Cancel previous request
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      const controller = new AbortController();
      controllerRef.current = controller;

      const reqObj: any = {
        draw: 1,
        start: 0,
        length: 10,
        filter: filters.join(",") || "",
        search: {
          value: searchValue,
          regex: false,
        },
      };
      if (activityPayload) {
        reqObj.activityFilter = activityPayload;
      }
      if (devicePayload) {
        reqObj.deviceFilter = devicePayload;
      }
      if (cityPayload?.cityId?.length) {
        reqObj.cityId = cityPayload.cityId;
      }

      const response = await axios.post(
        `${url.BASE_URL}${url.GET_USERS_DETAIL_URL}`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );

      const res: PremisesListResponse = response.data;
      setRecordsTotal(res.recordsTotal ?? null);
      setRecordsFiltered(res.recordsFiltered ?? null);
      toast.success("Filter applied successfully");
    } catch (err: any) {
      if (err.name === "AbortError") {
        // Request was cancelled, ignore
        return true;
      }
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return false;
      } else {
        console.error("Error fetching data:", err);
        toast.error("Failed to apply filter");
      }
    } finally {
      setLoading(false);
    }

    return true;
  };
  const handlePresetSelect = (preset: any) => {
    setSelectedPresetId(preset?.id || preset?._id || null);
    const payload = preset?.filters || {};

    const rulesFromFilter = buildRulesFromFilter(payload.filter || "");
    const newRules: any[] = [...rulesFromFilter];

    if (payload.cityId && payload.cityId.length) {
      newRules.push({
        category: "onBoarded",
        option: "cityFilter",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: payload.cityId[0] || "",
        cityLabel: payload.city[0]?.name || "",
      });
    }

    if (payload.activityFilter) {
      newRules.push({
        category: "activity",
        option: "activityFilter",
        number: "",
        minutes: payload.activityFilter.minutes?.toString() || "",
        minCount: payload.activityFilter.minCount?.toString() || "",
        activityType: payload.activityFilter.filterType || "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      });
    }

    if (payload.deviceFilter) {
      newRules.push({
        category: "device",
        option: "deviceFilter",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: payload.deviceFilter.filterType || "",
        deviceCount: payload.deviceFilter.filterCount || "",
        deviceState: payload.deviceFilter.filterState || "",
        cityIds: "",
        cityLabel: "",
      });
    }

    if (!newRules.length) {
      newRules.push({
        category: "",
        option: "",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      });
    }

    setRules(newRules);
    setRuleErrors(newRules.map(() => ({})));

    setSegmentFormData({
      name: preset?.name || "",
      description: preset?.description || "",
      updateCycle: preset?.updateCycle || "daily",
      isLiveSegmentation: preset?.isLiveSegmentation ?? true,
      isActive: preset?.isActive || true,
    });

    appliedFiltersRef.current = (payload.filter || "")
      .split(",")
      .map((p: string) => p.trim())
      .filter(Boolean);
    setAppliedFilters(appliedFiltersRef.current);

    const activityPayload = payload.activityFilter || null;
    const devicePayload = payload.deviceFilter || null;
    const cityPayload =
      payload.cityId && payload.cityId.length
        ? { cityId: payload.cityId }
        : null;

    activityFilterRef.current = activityPayload;
    deviceFilterRef.current = devicePayload;
    cityFilterRef.current = cityPayload;

    dispatch(setActivityFilter(activityPayload));
    dispatch(setDeviceFilter(devicePayload));
    dispatch(setCityFilter(cityPayload));

    if (payload.search && typeof payload.search.value === "string") {
      setSearchValue(payload.search.value);
    }

    setHasApplied(false);
    // destroyDataTable();
  };

  const handleUpdateSegment = async () => {
    if (!segmentFormData.name.trim()) {
      toast.error("Please enter a segment name");
      return;
    }

    if (!selectedPresetId) {
      toast.error("No segment selected for update");
      return;
    }

    try {
      setLoading(true);

      // Use applied filters if available, otherwise build from rules
      let filters: string[] = [];
      let activityPayload: ActivityFilterPayload | null = null;
      let devicePayload: DeviceFilterPayload | null = null;
      let cityPayload: CityFilterPayload | null = null;

      if (hasApplied && appliedFiltersRef.current.length > 0) {
        // Use already applied filters
        filters = appliedFiltersRef.current;
        activityPayload = activityFilterRef.current;
        devicePayload = deviceFilterRef.current;
        cityPayload = cityFilterRef.current;
      } else {
        // Build from current rules
        const validated = validateFilters();
        if (!validated) {
          toast.error("Please apply valid filters before updating segment");
          setLoading(false);
          return;
        }
        const result = buildFilters(rules);
        filters = result.filters;
        activityPayload = result.activityPayload;
        devicePayload = result.devicePayload;
        cityPayload = result.cityPayload;
      }

      const filtersObj: any = {
        draw: 1,
        order: [],
        start: 0,
        length: 100,
        search: {
          value: searchValue || "",
          regex: false,
        },
        filter: filters.join(",") || "",
        filterType: 1,
        cityId: cityPayload?.cityId || [],
      };

      if (activityPayload) {
        filtersObj.activityFilter = activityPayload;
      }
      if (devicePayload) {
        filtersObj.deviceFilter = devicePayload;
      }

      const payload = {
        name: segmentFormData.name,
        description: segmentFormData.description || "",
        filters: filtersObj,
        userIds: [], // Will be populated based on filtered results
        updateCycle: segmentFormData.updateCycle,
        totalUsersCount: recordsFiltered || 0,
        percentage: 0,
        isLiveSegmentation: segmentFormData.isLiveSegmentation,
        isActive: segmentFormData.isActive,
      };

      const response = await Request.put(
        `${url.BASE_URL}${url.UPDATE_FILTER_SEGMENT}/${selectedPresetId}`,
        payload
      );

      toast.success("Segment updated successfully");
      setEditSegmentModalOpen(false);
      setSelectedPresetId(null);
      setSegmentFormData({
        name: "",
        description: "",
        updateCycle: "daily",
        isLiveSegmentation: true,
        isActive: true,
      });
      // Close advanced filter and show segment table
      setOpenAdvancedFilter(false);
    } catch (error: any) {
      console.error("Error updating segment:", error);
      if (error?.response && error.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to update segment"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSaveSegmentModal = () => {
    // Validate filters before opening modal
    const validated = validateFilters();
    if (!validated) {
      return;
    }
    setSaveSegmentModalOpen(true);
  };

  const handleSaveSegment = async () => {
    if (!segmentFormData.name.trim()) {
      toast.error("Please enter a segment name");
      return;
    }

    try {
      setLoading(true);

      // Use applied filters if available, otherwise build from rules
      let filters: string[] = [];
      let activityPayload: ActivityFilterPayload | null = null;
      let devicePayload: DeviceFilterPayload | null = null;
      let cityPayload: CityFilterPayload | null = null;

      if (hasApplied && appliedFiltersRef.current.length > 0) {
        // Use already applied filters
        filters = appliedFiltersRef.current;
        activityPayload = activityFilterRef.current;
        devicePayload = deviceFilterRef.current;
        cityPayload = cityFilterRef.current;
      } else {
        // Build from current rules
        const validated = validateFilters();
        if (!validated) {
          toast.error("Please apply valid filters before saving segment");
          setLoading(false);
          return;
        }
        const result = buildFilters(rules);
        filters = result.filters;
        activityPayload = result.activityPayload;
        devicePayload = result.devicePayload;
        cityPayload = result.cityPayload;
      }

      const filtersObj: any = {
        draw: 1,
        order: [],
        start: 0,
        length: 100,
        search: {
          value: searchValue || "",
          regex: false,
        },
        filter: filters.join(",") || "",
        filterType: 1,
        cityId: cityPayload?.cityId || [],
      };

      if (activityPayload) {
        filtersObj.activityFilter = activityPayload;
      }
      if (devicePayload) {
        filtersObj.deviceFilter = devicePayload;
      }

      const payload = {
        name: segmentFormData.name,
        description: segmentFormData.description || "",
        filters: filtersObj,
        userIds: [], // Will be populated based on filtered results
        updateCycle: segmentFormData.updateCycle,
        totalUsersCount: recordsFiltered || 0,
        percentage: 0,
        isLiveSegmentation: segmentFormData.isLiveSegmentation,
        isActive: segmentFormData.isActive,
      };

      const response = await Request.post(
        `${url.BASE_URL}${url.ADD_FILTER_SEGMENT}`,
        payload
      );

      toast.success("Segment saved successfully");
      setSaveSegmentModalOpen(false);
      setSegmentFormData({
        name: "",
        description: "",
        updateCycle: "daily",
        isLiveSegmentation: true,
        isActive: true,
      });
      // Close advanced filter and show segment table
      setOpenAdvancedFilter(false);
    } catch (error: any) {
      console.error("Error saving segment:", error);
      if (error?.response && error.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      } else {
        toast.error(error?.response?.data?.message || "Failed to save segment");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div>
        <ToastContainer />
        {isOpenAdvancedFilter && (
          <Row>
            <Col>
              <Card
                //   className="shadow"
                style={{
                  marginTop: 100,
                  marginLeft: 30,
                  marginRight: 30,
                  marginBottom: 0,
                }}
              >
                <CardBody>
                  <Row>
                    <Col
                      // md={10}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "12px",
                            gap: 12,
                          }}
                        >
                          <h5 className="m-0">Advanced Filter</h5>

                          <div
                            className="d-flex"
                            style={{
                              gap: 8,
                              justifyContent: "center",
                              alignItems: "anchor-center",
                            }}
                          >
                            <Button
                              color="danger"
                              size="sm"
                              disabled={loading}
                              onClick={() => {
                                const clearedFilters: any = [];
                                appliedFiltersRef.current = clearedFilters;
                                activityFilterRef.current = null;
                                deviceFilterRef.current = null;
                                cityFilterRef.current = null;
                                setCityOptions([]);
                                setAppliedFilters(clearedFilters);
                                dispatch(getSelectedFilter(clearedFilters));
                                dispatch(setActivityFilter(null));
                                dispatch(setDeviceFilter(null));
                                dispatch(setCityFilter(null));
                                resetAdvanceFilterCount();
                                setRules([
                                  {
                                    category: "",
                                    option: "",
                                    number: "",
                                    minutes: "",
                                    minCount: "",
                                    activityType: "",
                                    deviceType: "",
                                    deviceCount: "",
                                    deviceState: "",
                                    cityIds: "",
                                    cityLabel: "",
                                  },
                                ]);
                                setRuleErrors([{}]);
                                setHasApplied(false);
                                setRecordsTotal(null);
                                setRecordsFiltered(null);
                              }}
                            >
                              Clear All
                            </Button>
                            <Button
                              className="btn btn-dark"
                              size="sm"
                              disabled={loading}
                              onClick={() => {
                                const clearedFilters: any = [];
                                appliedFiltersRef.current = clearedFilters;
                                activityFilterRef.current = null;
                                deviceFilterRef.current = null;
                                cityFilterRef.current = null;
                                setCityOptions([]);
                                setAppliedFilters(clearedFilters);
                                dispatch(getSelectedFilter(clearedFilters));
                                dispatch(setActivityFilter(null));
                                dispatch(setDeviceFilter(null));
                                dispatch(setCityFilter(null));
                                resetAdvanceFilterCount();
                                setRules([
                                  {
                                    category: "",
                                    option: "",
                                    number: "",
                                    minutes: "",
                                    minCount: "",
                                    activityType: "",
                                    deviceType: "",
                                    deviceCount: "",
                                    deviceState: "",
                                    cityIds: "",
                                    cityLabel: "",
                                  },
                                ]);
                                setRuleErrors([{}]);
                                setHasApplied(false);
                                setRecordsTotal(null);
                                setRecordsFiltered(null);
                                setSelectedPresetId(null);
                                toggleAdvanceFilter();
                              }}
                            >
                              Exit
                            </Button>
                          </div>
                        </div>

                        <Row>
                          <Col md={10}>
                            <SelectFilters
                              rules={rules}
                              ruleErrors={ruleErrors}
                              filterConfig={FILTER_CONFIG}
                              cityOptions={cityOptions}
                              getSelectValue={getSelectValue}
                              getCitySelectedOption={getCitySelectedOption}
                              fetchCityOptions={fetchCityOptions}
                              updateCategory={updateCategory}
                              updateOption={updateOption}
                              updateNumber={updateNumber}
                              updateMinutes={updateMinutes}
                              updateMinCount={updateMinCount}
                              updateActivityType={updateActivityType}
                              updateDeviceType={updateDeviceType}
                              updateDeviceCount={updateDeviceCount}
                              updateDeviceState={updateDeviceState}
                              updateCityIds={updateCityIds}
                              removeRule={removeRule}
                              addRule={addRule}
                            />
                          </Col>
                          <Col md={2} className="d-flex flex-column gap-2">
                            <FilterStatisticsCards
                              hasApplied={hasApplied}
                              loading={loading}
                              recordsTotal={recordsTotal}
                              recordsFiltered={recordsFiltered}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div
                        className="d-flex justify-content-end mt-3"
                        style={{ gap: 8 }}
                      >
                        {selectedPresetId && (
                          <Button
                            // color="primary"
                            className="btn btn-dark"
                            size="sm"
                            disabled={loading}
                            onClick={() => setEditSegmentModalOpen(true)}
                          >
                            Update Segment
                          </Button>
                        )}
                        {!selectedPresetId && (
                          <Button
                            // color="primary"
                            className="btn btn-dark"
                            size="sm"
                            disabled={loading}
                            onClick={handleOpenSaveSegmentModal}
                          >
                            Save Segment
                          </Button>
                        )}
                        <Button
                          // color="primary"
                          className="btn btn-dark"
                          size="sm"
                          disabled={loading}
                          onClick={handleApplyFilter}
                        >
                          {loading && (
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                          Apply
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {!isOpenAdvancedFilter && (
          <SegmentTable
            onToggleAdvancedFilter={toggleAdvanceFilter}
            onSelect={(preset: any) => handlePresetSelect(preset)}
          />
        )}

        {/* Save Segment Modal */}
        <SaveSegment
          isOpen={isSaveSegmentModalOpen}
          toggle={() => setSaveSegmentModalOpen(false)}
          loading={loading}
          segmentFormData={segmentFormData}
          setSegmentFormData={setSegmentFormData}
          recordsFiltered={recordsFiltered}
          onSave={handleSaveSegment}
        />

        {/* Edit Segment Modal */}
        <EditSegment
          isOpen={isEditSegmentModalOpen}
          toggle={() => {
            setEditSegmentModalOpen(false);
          }}
          loading={loading}
          segmentFormData={segmentFormData}
          setSegmentFormData={setSegmentFormData}
          recordsFiltered={recordsFiltered}
          selectedPresetId={selectedPresetId}
          onUpdate={handleUpdateSegment}
        />
      </div>
    </React.Fragment>
  );
};

export default Index;
